import React from 'react';
import '../styles/Products.css';
import ProductsPage from './ProductsPage';
const Products = () => {


    return (
        <div className="products-page">
            {/* Hero Section */}
            <div className="hero">
                <h1>Quality Pharma Products for a Healthier Future</h1>
                <p>Discover our premium range of pharmaceutical solutions trusted by healthcare professionals.</p>
                <a href="/products" className="cta-button">Explore Products</a>
            </div>
      <ProductsPage />
        </div>
    );
};

export default Products;